import { Component } from '@angular/core'

@Component({
  selector: 'se-po-phone-docs',
  templateUrl: './phone-docs.component.html',
  styleUrls: ['./phone-docs.component.scss'],
  standalone: false,
})
export class PhoneDocsComponent {
}
